import styled from "styled-components";

export const ComponentBaseContainer = styled.div`
    height:90vh;
    display:flex;
    color:white;
    align-items:center;
    margin:10px;
    padding:10px;
    .ace_marker-layer .diff-add {
    position: absolute;
  background-color: rgba(76, 175, 80, 0.3); /* green */
}

.ace_marker-layer .diff-remove {
position: absolute;
  background-color: rgba(244, 67, 54, 0.3); /* red */
}
`;
